import { WaitingDots } from 'components/WaitingDots/WaitingDots';
import { confirmEmailOnEnterSaga } from './ConfirmEmail.onenter.saga'; // polyfill webpack require.ensure

if (typeof require.ensure !== 'function') require.ensure = function (deps, cbFn) {
  return cbFn(require);
};
export var ConfirmEmailRoute = function ConfirmEmailRoute(store, client) {
  return {
    path: '/confirm/:key',
    onEnter: function onEnter(nextState, replaceState, cb) {
      return store.runSagaOnce(confirmEmailOnEnterSaga, client, nextState, replaceState).done.then(cb, cb);
    },
    component: WaitingDots
  };
};